export const config = {
    url: '',
    // http://192.168.10.109:1080
    // AngularMVC/UserDashboard
}